import { environment } from 'src/environments/environment';

export const NO_LOGO_IMAGE = 'assets/images/no-logo.png';

const PROVIDER_HOSTS = new Set(['img.logo.dev', 'logo.clearbit.com']);
const DIRECT_IMAGE_URL = /\.(?:avif|gif|jpe?g|png|svg|webp)(?:$|[?#])/i;
const LOCAL_IMAGE_URL = /^(?:\.?\.?\/|\/)?assets\//i;
const CACHE_HOST = new URL(environment.logoCacheBaseUrl).hostname;

export function getLogoUrl(
  value: string | null | undefined,
  _size: number = 80,
  _greyscale: boolean = false,
): string {
  const rawValue = value?.trim();
  if (!rawValue) return NO_LOGO_IMAGE;

  if (/^(?:data:image\/|blob:)/i.test(rawValue) || LOCAL_IMAGE_URL.test(rawValue)) {
    return rawValue;
  }

  try {
    const absolute = /^(?:https?:)?\/\//i.test(rawValue);
    const url = new URL(
      absolute
        ? rawValue.startsWith('//') ? `https:${rawValue}` : rawValue
        : `https://${rawValue}`,
    );

    if (url.hostname === CACHE_HOST) return rawValue;
    if (absolute && !PROVIDER_HOSTS.has(url.hostname) && DIRECT_IMAGE_URL.test(rawValue)) {
      return rawValue;
    }

    const domain = PROVIDER_HOSTS.has(url.hostname)
      ? decodeURIComponent(url.pathname.split('/').filter(Boolean)[0] || '')
      : url.hostname;
    return buildCachedLogoUrl(domain);
  } catch {
    const domain = rawValue
      .toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/^\/\//, '')
      .split(/[/?#]/)[0];
    return buildCachedLogoUrl(domain) || rawValue;
  }
}

function buildCachedLogoUrl(value: string): string {
  const domain = value.trim().toLowerCase().replace(/^www\./, '').replace(/\.$/, '');
  if (!domain.includes('.') || /[\s/@]/.test(domain)) return '';
  return `${environment.logoCacheBaseUrl.replace(/\/+$/, '')}/${encodeURIComponent(domain)}`;
}
